<template>
  <div>
    <div class="grid ver-padding-40">
      <h1 class="r-margin-30">Пользователь: {{ form.full_name }}</h1>
    </div>

    <div v-loading="loading">
      <form
        @submit.prevent="onSubmit"
        @keypress.enter="pressEnter"
        class="grid"
      >
        <div class="u-16 page-block grid controls-inline">
          <!-- active -->
          <div class="r-margin-20">
            <AppCheckbox v-model="form.active" id="option-active"
              >Включен</AppCheckbox
            >
          </div>
          <!-- is_admin -->
          <div>
            <AppCheckbox v-model="form.is_admin" id="option-admin"
              >Админ</AppCheckbox
            >
          </div>
        </div>

        <div class="page-block u-16 grid cross-center between">
          <!-- email -->
          <div class="u-16 u-8-ls r-padding-0 r-padding-10-ls">
            <AppInput
              v-model="form.email"
              label="Email"
              size="medium"
              required
              @blur="validateEmail(form.email, true)"
              @input="validateEmail(form.email, false)"
            ></AppInput>
          </div>
          <!-- full_name -->
          <div
            class="u-16 u-8-ls ver-margin-20 ver-margin-0-ls l-padding-0 l-padding-10-ls"
          >
            <AppInput
              v-model="form.full_name"
              label="Полное имя"
              size="medium"
            ></AppInput>
          </div>
          <div class="u-16 ver-margin-0 ver-margin-10-ls"></div>
        </div>

        <div class="page-block u-16 grid">
          <!-- merchants -->
          <div class="u-16">
            <label>Предприятия</label>
            <el-select
              v-model="form.access_list.Merchants"
              filterable
              multiple
              clearable
              placeholder
              size="large"
              @change="handleChange"
            >
              <el-option
                v-for="(item, index) in merchantList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <!-- terminals -->
          <div class="u-16">
            <label>Терминалы</label>
            <el-select
              v-model="form.access_list.Terminals"
              filterable
              multiple
              clearable
              placeholder
              size="large"
            >
              <el-option
                v-for="(item, index) in sortTerminals"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <!-- processings -->
          <div class="u-16">
            <label>Процессинги</label>
            <el-select
              v-model="form.access_list.Processings"
              filterable
              multiple
              clearable
              placeholder
              size="large"
            >
              <el-option
                v-for="(item, index) in sortProcessings"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="page-block u-16 grid">
          <!-- rights -->
          <div class="u-16 hor-padding-10">
            <label>Права</label>
            <el-select
              v-model="form.rights"
              filterable
              multiple
              placeholder
              :disabled="form.is_admin"
              size="large"
            >
              <el-option
                v-for="item in rightsList"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <!-- submit -->
        <div class="u-16 gird ver-margin-20">
          <AppButton type="green" class="r-margin-20" :disabled="is_disabled"
            >Изменить</AppButton
          >
          <AppButton type="border" @click.prevent="cancel">Отменить</AppButton>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import { apiUrl } from "@/api/apiUrl";
import { mapGetters } from "vuex";
import { _ } from "vue-underscore";
import axios from "axios";
import VueAxios from "vue-axios";
import rightsList from "@/localize/rightsList.js";
Vue.use(VueAxios, axios);

export default {
  name: "AddUser",
  data() {
    return {
      loading: false,
      user: null,
      form: {
        active: false,
        is_admin: false,
        email: "",
        full_name: "",
        access_list: {
          Processings: [],
          Merchants: [],
          Terminals: []
        },
        rights: []
      },
      rightsList: [...rightsList],
      is_disabled: true
    };
  },
  methods: {
    onSubmit() {
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      let editUser = Object.assign({}, _.omit(this.form, "is_confirm_email"));
      for (let key in editUser) {
        console.log("TCL: onSubmit -> key", key);
        // enable/disable user
        if (key == "active")
          if (editUser[key] != this.user[key]) {
            axios
              .post(
                apiUrl + "user/switch/" + editUser.id,
                { active: editUser[key] },
                config
              )
              .catch(e => console.log(e));
          } else editUser = _.omit(editUser, key);

        // change true/false to 1/-1 for `is_admin`
        if (key == "is_admin") {
          if (editUser[key] == this.user[key]) {
            editUser = _.omit(editUser, key);
          } else {
            editUser[key] = editUser[key] == true ? 1 : -1;
          }
        }

        // for deleting rights
        if (key == "rights" && editUser[key].length == 0) {
          editUser = _.omit(editUser, key);
          editUser.delete_rights = true;
        }

        // exclude props without changes
        if (_.isObject(editUser[key]) || _.isArray(editUser[key])) {
          if (_.isEqual(editUser[key], this.user[key]))
            editUser = _.omit(editUser, key);
        } else {
          if (_.isString(editUser[key]) && editUser[key] == this.user[key])
            editUser = _.omit(editUser, key);
        }
      }

      axios
        .post(apiUrl + "user/edit", { id: this.form.id, ...editUser }, config)
        .then(({ data }) => {
          if (data.state_id == 0) {
            this.$message({
              message: "Пользователь успешно изменен",
              type: "success",
              duration: 2000
            });
            if (editUser.email && editUser.email != this.user.email)
              this.sendEmail(this.form.id);
          }
        })
        .then(() => {
          this.$router.push({
            name: "s_Users"
          });
        })
        .catch(err => {
          if (err.response)
            this.$message({
              message: err.response.data.message,
              type: "error",
              duration: 2000
            });
        });
    },
    sendEmail(userId) {
      let host = "";
      let path = "/";
      let origin = window.location.origin;
      if (/bo-dev|localhost/.test(origin)) {
        host = "https://auth-dev.mapcard.pro";
        path = apiUrl.match(/\/(feature-.*|develop)\//)[0];
      }
      if (/bo-stage/.test(origin)) host = "https://auth-stage.mapcard.pro";
      if (/bo-evo/.test(origin)) host = "https://auth-evo.mapcard.pro";
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      axios
        .post(
          host + path + "change-password",
          { id: userId, reset_password: true },
          config
        )
        .then(({ data }) => {
          if (data.state_id == 0)
            this.$message({
              message: "Письмо на сброс пароля отправлено",
              type: "success",
              duration: 2000
            });
        })
        .catch(err => {
          if (err.response)
            this.$message({
              message: err.response.data.message,
              type: "error",
              duration: 2000
            });
        });
    },
    cancel() {
      this.$router.push({
        name: "s_Users",
        params: { id: this.form.id, filter: this.$route.params.filter }
      });
    },
    handleChange(e) {
      this.form.access_list.Terminals =
        e.length > 0 ? _.map(this.sortTerminals, "id") : [];
      this.form.access_list.Processings =
        e.length > 0 ? _.map(this.sortProcessings, "id") : [];
    },
    pressEnter(e) {
      e.preventDefault();
    },
    fillForm() {
      const user = Object.assign({}, this.user);
      for (let key in user) {
        if (user.hasOwnProperty(key)) {
          if (key == "access_list") {
            for (let k in user[key]) {
              this.form[key][k] = user[key][k] || [];
            }
          }
          if (
            _.isString(user[key]) ||
            _.isBoolean(user[key]) ||
            _.isNumber(user[key])
          )
            this.form[key] = user[key];
          if (_.isArray(user[key])) this.form[key] = user[key] || [];
        }
      }
      this.validateEmail(this.form.email);
    },
    loadUser(id) {
      this.loading = true;
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      axios
        .get(apiUrl + "user/list/" + id, config)
        .then(({ data }) => {
          if (data.state_id == 0) {
            this.user = Object.assign({}, data.list[0]);
            this.loading = false;
          }
        })
        .then(() => {
          this.fillForm();
        })
        .catch(err => {
          console.log(err);
          false;
        });
    },
    validateEmail(email, is_shown_message) {
      if (email) {
        let re = /^[a-zа-яA-ZА-Я0-9._%+\-]+@[a-zа-яA-ZА-Я0-9.\-]+\.[a-zа-яA-ZА-Я]{2,12}$/;
        setTimeout(() => {
          if (!re.test(email.toLowerCase())) {
            if (is_shown_message)
              this.$message({
                message: "Введите корректный email",
                type: "error",
                duration: 2000
              });
            this.is_disabled = true;
            return false;
          } else {
            this.is_disabled = false;
            return true;
          }
        }, 300);
      } else {
        if (is_shown_message)
          this.$message({
            message: "Введите email",
            type: "error",
            duration: 2000
          });
        this.is_disabled = true;
        return false;
      }
    }
  },
  created() {
    let id = parseInt(this.$route.params.id);
    this.loadUser(id);
    if (!this.merchantList || this.merchantList.length == 0)
      this.$store.dispatch("getMerchant");
    if (!this.terminalList || this.terminalList.length == 0)
      this.$store.dispatch("getTerminal");
    if (!this.processingList && this.processingList.length == 0)
      this.$store.dispatch("getProcessing");
  },
  mounted() {},
  computed: {
    ...mapGetters(["merchantList", "terminalList", "processingList"]),
    sortTerminals() {
      let merchants = this.form.access_list.Merchants;
      let terminals = this.terminalList;
      let arr = [];
      if (merchants.length > 0) {
        terminals = terminals.filter(
          el => merchants.indexOf(el.merchant_id) != -1
        );
      }
      return terminals;
    },
    sortProcessings() {
      let terminals = this.sortTerminals;
      let processings = this.processingList;
      let arr = [];
      if (terminals.length > 0) {
        processings = processings.filter(el => {
          return terminals.find(item => item.processing_id == el.id);
        });
      }
      return processings;
    }
  }
};
</script>
